export default __webpack_public_path__ + "static/media/mtn-ilula.6e66aa48.png";